import React, { useContext } from 'react';
import { Link } from '@tanstack/react-router';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './GalleryStrip.module.scss';

const GalleryStrip = () => {
  const destination = useContext(DestinationContext);

  // `images.home` is the dedicated homepage gallery set; if the admin hasn't
  // populated it (or hasn't added enough), fall back to the other per-page
  // image sets already populated for every destination instead of a thin/blank section.
  const sourceLists = [
    destination?.images?.home,
    destination?.images?.accommodation,
    destination?.images?.safari,
    destination?.images?.destination,
    destination?.images?.about,
  ];

  const seen = new Set();
  const images = sourceLists
    .flat()
    .filter((img) => img?.url && !seen.has(img.url) && seen.add(img.url))
    .slice(0, 8);

  if (images.length === 0) return null;

  const galleryContent = destination?.galleryContent;

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div>
            <div className={styles.eyebrow}>{galleryContent?.eyebrow || `${destination?.name || 'The Destination'} in Pictures`}</div>
            {galleryContent?.title ? (
              <h2
                className={styles.heading}
                dangerouslySetInnerHTML={{ __html: galleryContent.title }}
              />
            ) : (
              <h2 className={styles.heading}>A Glimpse of What Awaits</h2>
            )}
          </div>
          <Link className={styles.plan} to="/accommodation">Plan Your Visit →</Link>
        </div>
        <div className={styles.gal}>
          {images.map((img) => (
            <div key={img.url} className={styles.cell}>
              <img
                src={img.url}
                alt={img.title || destination?.name}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryStrip;
